<template>
  <div v-if="isMobile">
    <a
      v-if="lpuAddress.show_phone && lpuAddress.lpu.lpuphone?.phone"
      v-ripple
      data-qa="lpu_card_btn_phone"
      class="d-flex align-center text-decoration-none text-body-1 primary--text py-2 mt-2"
      data-ya-goals-appointment="mobile_appointment__phone_action"
      data-google-goal="appointment_phone_action"
      :href="`tel:${rawPhone}`"
      :data-club-appointment-notice="/* TODO: переписать с импортом компонента */JSON.stringify({
        isDirect: !!selectedItem.workplace?.appointment_direct,
        isClub: lpuAddress.tabs_data?.in_club,
        price: lpuAddress.tabs_data?.club_price,
        priceFull: lpuAddress.tabs_data?.price,
        phoneNumber: lpuAddress.lpu.lpuphone.phone,
        country: lpuAddress.lpu.town.region.country,
        appointmentLink: `${urls?.createAppointmentForm}?doctor=${doctor?.id}&type=club&lpu=${lpuAddress.lpu.id}`,
      })"
    >
      <v-icon
        size="20"
        class="mr-4"
        color="icon-secondary"
      >
        ui-icon-phone-call
      </v-icon>
      {{ formattedPhone }}
    </a>
    <div v-else-if="lpuAddress.lpu.is_show_registration_phone">
      <a
        v-ripple
        class="d-flex align-center text-decoration-none text-body-1 primary--text py-2 mt-2"
        :href="`tel:${rawPhone}`"
      >
        <v-icon
          size="20"
          class="mr-4"
          color="icon-secondary"
        >
          ui-icon-phone-call
        </v-icon>
        {{ formattedPhone }}
      </a>
      <div class="d-flex align-center text-body-1 py-2 mt-2">
        <v-icon
          size="20"
          class="mr-4"
          color="icon-secondary"
        >
          ui-icon-wallet
        </v-icon>
        {{ t('По ОМС приём бесплатный', options) }}
      </div>
    </div>
  </div>
  <div v-else>
    <div
      v-if="lpuAddress.show_phone && lpuAddress.lpu.lpuphone?.phone || lpuAddress.lpu.is_show_registration_phone"
      class="d-flex align-center text-decoration-none text-body-1 py-2 mt-2"
    >
      <v-icon
        size="20"
        class="mr-4"
        color="icon-secondary"
      >
        ui-icon-phone-call
      </v-icon>
      {{ formattedPhone }}
    </div>
    <div
      v-if="lpuAddress.lpu.is_show_registration_phone"
      class="d-flex align-center text-body-1 py-2 mt-2"
    >
      <v-icon
        size="20"
        class="mr-4"
        color="icon-secondary"
      >
        ui-icon-wallet
      </v-icon>
      {{ t('По ОМС приём бесплатный', options) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import formatPhone from 'src/functions/formatPhone'
import { LpuAddressList } from 'www/vue_components/common/DoctorPageLpuList/types'
import { useExternalDataStore } from 'www/vue_components/common/DoctorPageLpuList/stores'
import { useDoctorAppointmentCardStore } from 'www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/stores'

const props = defineProps<{
  lpuAddress: LpuAddressList[number]
}>()

const { t, language } = I18NextVue
const options = { ns: language }

const externalDataStore = useExternalDataStore()
const { urls, doctor, isMobile } = storeToRefs(externalDataStore)

const doctorAppointmentCardStore = useDoctorAppointmentCardStore(props.lpuAddress.lpu_id)()
const { selectedItem } = storeToRefs(doctorAppointmentCardStore)

const phone = computed(() => {
  if (props.lpuAddress.show_phone && props.lpuAddress.lpu.lpuphone?.phone) {
    return props.lpuAddress.lpu.lpuphone.phone
  }

  if (props.lpuAddress.lpu.is_show_registration_phone) {
    return props.lpuAddress.phone
  }

  return ''
})

const formattedPhone = computed(() => formatPhone({
  phone: phone.value,
  country: props.lpuAddress.lpu.town.region.country,
  isRaw: false,
}))
const rawPhone = computed(() => formatPhone({
  phone: phone.value,
  country: props.lpuAddress.lpu.town.region.country,
  isRaw: true,
}))
</script>
